import { FC } from 'react';
import { Skeleton } from 'antd';
import styles from './index.module.less';

interface AIEvaluationProps {
  /** 当前点位的 AI 评价文案 */
  comment?: string;
  /** AI 评价是否生成中 */
  loading: boolean;
  /** AI 评价是否生成失败 */
  failed: boolean;
}

/**
 * @description 单个点位的 AI 评价展示
 * 请求和状态由 useAIEvaluation 统一管理，本组件只负责展示
 */
const AIEvaluation: FC<AIEvaluationProps> = ({
  comment,
  loading,
  failed,
}) => {
  if (loading) {
    return (
      <div className={styles.aiBox}>
        <Skeleton
          active
          title={false}
          paragraph={{ rows: 3, width: ['100%', '100%', '80%'] }}
        />
      </div>
    );
  }

  return (
    <div className={styles.aiBox}>
      <span className={styles.aiTag}>AI评价</span>
      {failed ? (
        <span className={styles.aiFailed}>AI评价生成失败</span>
      ) : comment ? (
        <span className={styles.aiComment}>{comment}</span>
      ) : (
        <span className={styles.aiEmpty}>暂无评价</span>
      )}
    </div>
  );
};

export default AIEvaluation;
